import React from 'react';

const AI_PRODUCTIVITY_SPARKLE_PATH =
    'M11.5449 2.20117C11.7229 1.8113 12.2771 1.8113 12.4551 2.20117L14.2207 6.07031C14.9703 7.71285 16.2872 9.02968 17.9297 9.7793L21.7988 11.5449C22.1887 11.7229 22.1887 12.2771 21.7988 12.4551L17.9297 14.2207C16.2872 14.9703 14.9703 16.2872 14.2207 17.9297L12.4551 21.7988C12.2771 22.1887 11.7229 22.1887 11.5449 21.7988L9.7793 17.9297C9.02968 16.2872 7.71285 14.9703 6.07031 14.2207L2.20117 12.4551C1.8113 12.2771 1.8113 11.7229 2.20117 11.5449L6.07031 9.7793C7.71285 9.02968 9.02968 7.71285 9.7793 6.07031L11.5449 2.20117Z';

const AiProductivityFeatureIcon = () => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        data-testid="ai-productivity-feature-icon"
    >
        <path d={AI_PRODUCTIVITY_SPARKLE_PATH} stroke="#3a6767" strokeWidth={1} fill="none" />
    </svg>
);

export default AiProductivityFeatureIcon;
